/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Code_HeadingInputs */

const en_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const de_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie Ihre E-Mails`)
};

const pt_br2_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique seu e-mail`)
};

const tr_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postanızı kontrol edin`)
};

const zh_cn2_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看您的电子邮箱`)
};

const zh_hk2_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看你的電郵`)
};

const ko_kr2_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일을 확인하세요`)
};

const ru_ru2_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте почту`)
};

const es_419_login_page_code_heading = /** @type {(inputs: Login_Page_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Login_Page_Code_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_code_heading = /** @type {((inputs?: Login_Page_Code_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Code_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_code_heading(inputs)
	if (locale === "de") return de_login_page_code_heading(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_code_heading(inputs)
	if (locale === "tr") return tr_login_page_code_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_code_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_code_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_code_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_code_heading(inputs)
	return es_419_login_page_code_heading(inputs)
});